/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EmployeeCreateDTO,
  EmployeeListResponseDTO,
  EmployeePasswordUpdateDTO,
  EmployeeResponseDTO,
  EmployeeUpdateDTO,
  HTTPValidationError,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Employees<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Employees
   * @name GetEmployeesApiEmployeesGet
   * @summary Get Employees
   * @request GET:/api/employees
   * @response `200` `(EmployeeListResponseDTO)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getEmployeesApiEmployeesGet = (
    query?: {
      /**
       * Sort
       * @default "["id","DESC"]"
       */
      sort?: string;
      /**
       * Filter
       * @default "{}"
       */
      filter?: string;
      /**
       * Range
       * @default "[0,10]"
       */
      range?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EmployeeListResponseDTO[], HTTPValidationError>({
      path: `/api/employees`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employees
   * @name CreateEmployeesApiEmployeesPost
   * @summary Create Employees
   * @request POST:/api/employees
   * @response `200` `EmployeeResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createEmployeesApiEmployeesPost = (data: EmployeeCreateDTO, params: RequestParams = {}) =>
    this.request<EmployeeResponseDTO, HTTPValidationError>({
      path: `/api/employees`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employees
   * @name GetEmployeesDetailApiEmployeesIdGet
   * @summary Get Employees Detail
   * @request GET:/api/employees/{_id}
   * @response `200` `EmployeeResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getEmployeesDetailApiEmployeesIdGet = (id: number, params: RequestParams = {}) =>
    this.request<EmployeeResponseDTO, HTTPValidationError>({
      path: `/api/employees/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employees
   * @name UpdateEmployeesApiEmployeesIdPut
   * @summary Update Employees
   * @request PUT:/api/employees/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateEmployeesApiEmployeesIdPut = (id: number, data: EmployeeUpdateDTO, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/employees/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Employees
   * @name DeleteEmployeesApiEmployeesIdDelete
   * @summary Delete Employees
   * @request DELETE:/api/employees/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteEmployeesApiEmployeesIdDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/employees/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employees
   * @name UpdateEmployeePasswordApiEmployeesIdPasswordPatch
   * @summary Update Employee Password
   * @request PATCH:/api/employees/{_id}/password
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateEmployeePasswordApiEmployeesIdPasswordPatch = (
    id: number,
    data: EmployeePasswordUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/employees/${id}/password`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
